"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/Forms/PatientOrgChoice.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _Form = require('web/components/Form');
var _WarningBar = require('web/components/WarningBar'); var _WarningBar2 = _interopRequireDefault(_WarningBar);







// A required, initially empty org choice for a new patient.
const PatientOrgChoice = ({ orgs, value, onChange }) => {
  const hintId = _react.useId.call(void 0, )

  if (!orgs.length) {
    return (
      _react2.default.createElement(_WarningBar2.default, {
        className: "directory--create-new--warning",
        text: "None of your organizations have patient messaging turned on, so you can't add a patient."              , __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}
      )
    )
  }

  return (
    _react2.default.createElement(_Form.InputSectionWrapper, {
      title: "Organization",
      className: "invite-contact--org-picker", __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}

      , _react2.default.createElement(_Form.SimpleSelect, {
        value: value,
        onChange: onChange,
        isRequired: true,
        describedBy: value ? undefined : hintId,
        options: [
          { value: '', label: 'Choose an organization' },
          ...orgs.map(org => ({ value: org.OrgKey, label: org.Name })),
        ], __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
      )
      ,  !value && (
        _react2.default.createElement('div', { className: "blm-input-section--extra", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
          , _react2.default.createElement('span', { id: hintId, className: "blm-input-section--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}, "Choose the patient's organization"

          )
        )
      )
    )
  )
}

exports. default = PatientOrgChoice
